import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")

  return (_openBlock(), _createBlock(_component_option_field, {
    modelValue: $options.selectedLanguage,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.selectedLanguage) = $event)),
    "display-name": $props.displayName,
    options: $options.supportedLanguages,
    "has-transparent-bg": $props.hasTransparentBg,
    layout: "condensed",
    class: "_mt-0",
    "data-qa": "footer-translation-dropdown"
  }, {
    label: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "display-name", "options", "has-transparent-bg"]))
}